"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ShowIfNotEmpty {
    constructor(container, baseClass) {
        this.container = container;
        this.baseClass = baseClass;
        const sidebar = this.container.querySelector(`.${this.baseClass}__sidebar`);
        if (sidebar) {
            this.checkForInnerBlocks(sidebar);
            this.listenForEndpointPosts(sidebar);
        }
    }
    checkForInnerBlocks(sidebar) {
        const innerBlocks = sidebar.querySelector(`.${this.baseClass}__inner-blocks`);
        if (innerBlocks && !innerBlocks.querySelector('innerblocks')) {
            this.removeDisplayNoneUtility(sidebar);
        }
    }
    listenForEndpointPosts(sidebar) {
        this.container.addEventListener('fetchingPosts', () => {
            this.removeDisplayNoneUtility(sidebar);
        });
    }
    removeDisplayNoneUtility(sidebar) {
        sidebar.classList.remove('u-display--none');
    }
}
exports.default = ShowIfNotEmpty;
